import { DatasetLoadingConf } from "components/dashboard/charts/interfaces";
import { T } from "services/lang/LanguageService";
import DatasetMultiSelect from "components/basic/dropdowns/dataset/DatasetMultiSelect";
import LoadConfigInputs, { DefaultDatasetLoadingConf } from "components/dashboard/charts/LoadConfigInputs";
import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import {
  DataType,
  dataTypeOptions,
  LineChartLegendEditorProps,
  LineChartLegendProps,
} from "../LineChartLegendTypes";

const LineChartLegendEditor = ({ config, onConfigChange }: LineChartLegendEditorProps) => {
  const [currentConfig, setCurrentConfig] = useState<LineChartLegendProps>({
    ...config,
    loadConf: config.loadConf ?? DefaultDatasetLoadingConf,
  });

  useEffect(() => {
    onConfigChange(currentConfig);
  }, [currentConfig]);

  return (
    <div className="flex flex-column gap-2">
      <div className="flex flex-row gap-2">
        <div className="flex flex-column gap-2">
          <label htmlFor="dataType">{T("label.data-type")}</label>
          <Dropdown
            id="dataType"
            options={dataTypeOptions}
            value={currentConfig.dataType ?? DataType.YEARS}
            onChange={e => setCurrentConfig({ ...currentConfig, dataType: e.value })}
          />
        </div>
      </div>
      <div className="flex flex-row gap-2">
        {currentConfig.dataType === DataType.DATASETS ? (
          <div className="flex flex-column gap-2 w-full">
            <label htmlFor="datasets">{T("word.datasets")}</label>
            <DatasetMultiSelect
              value={currentConfig.datasets}
              onChange={e => setCurrentConfig({ ...currentConfig, datasets: e })}
            />
          </div>
        ) : (
          <LoadConfigInputs
            loadConf={currentConfig.loadConf}
            handleLoadConfChange={(updatedLoadConf: DatasetLoadingConf) => {
              setCurrentConfig({ ...currentConfig, loadConf: updatedLoadConf });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default LineChartLegendEditor;
